module.exports = __webpack_public_path__ + "static/media/icon-notion.eae15a09.svg";